import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["onClick"]
const _hoisted_2 = ["onClick"]
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { for: "prompt-input" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = ["onClick"]

import { ref, nextTick, onUnmounted } from "vue";
import { useI18n } from "vue-i18n";
import Modal, { ModalIntrface } from "@/components/bootstrap/Modal.vue";
import {
  AlertService,
  ConfirmService,
  PromptService,
} from "@/components/diagnotics/DiagnoticsService";
import { assertIsDefined } from "@/utils/asserts";

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { t } = useI18n();
const alertMessage = ref<string>();
const alertModal = ref<ModalIntrface>();
const confirmMessage = ref<string>();
const confirmResult = ref<boolean>();
const confirmModal = ref<ModalIntrface>();
const promptMessage = ref<string>();
const promptInput = ref<string>();
const promptResult = ref<string | null>();
const promptModal = ref<ModalIntrface>();
{
  const _modal = alertModal;
  const _service = AlertService;
  async function pushed(): Promise<void> {
    let result;
    do {
      result = AlertService.shift();
      if (!result) continue;
      const [model, resolve] = result;
      alertMessage.value = model.message;
      console.debug({ alertMessage: alertMessage.value });
      await nextTick();
      const modal = _modal.value;
      assertIsDefined(modal);
      try {
        await modal.showAsync();
      } finally {
        resolve();
      }
    } while (result);
  }
  pushed();
  _service.on("pushed", pushed);
  async function clear() {
    await nextTick();
    const modal = _modal.value;
    if (modal == null) return;
    modal.hide();
  }
  _service.on("clear", clear);
  onUnmounted(() => {
    _service.off("pushed", pushed);
    _service.off("clear", clear);
  });
}
{
  const _modal = confirmModal;
  const _service = ConfirmService;
  async function pushed(): Promise<void> {
    let result;
    do {
      result = ConfirmService.shift();
      if (!result) continue;
      const [model, resolve] = result;
      confirmMessage.value = model.message;
      confirmResult.value = false;
      console.debug({
        confirmMessage: confirmMessage.value,
        confirmResult: confirmResult.value,
      });
      await nextTick();
      const modal = _modal.value;
      assertIsDefined(modal);
      try {
        await modal.showAsync();
      } finally {
        resolve(confirmResult.value);
      }
    } while (result);
  }
  pushed();
  _service.on("pushed", pushed);
  async function clear() {
    await nextTick();
    const modal = _modal.value;
    if (modal == null) return;
    modal.hide();
  }
  _service.on("clear", clear);
  onUnmounted(() => {
    _service.off("pushed", pushed);
    _service.off("clear", clear);
  });
}
{
  const _modal = promptModal;
  const _service = PromptService;
  async function pushed(): Promise<void> {
    let result;
    do {
      result = PromptService.shift();
      if (!result) return;
      const [model, resolve] = result;
      promptMessage.value = model.message;
      promptInput.value = model._default ?? "";
      promptResult.value = null;
      console.debug({
        promptMessage: promptMessage.value,
        promptInput: promptInput.value,
        promptResult: promptResult.value,
      });
      await nextTick();
      const modal = _modal.value;
      assertIsDefined(modal);
      try {
        await modal.showAsync();
      } finally {
        resolve(promptResult.value ?? null);
      }
    } while (result);
  }
  pushed();
  _service.on("pushed", pushed);
  async function clear() {
    await nextTick();
    const modal = _modal.value;
    if (modal == null) return;
    modal.hide();
  }
  _service.on("clear", clear);
  onUnmounted(() => {
    _service.off("pushed", pushed);
    _service.off("clear", clear);
  });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Modal, {
      id: "diagnotics-alert",
      ref_key: "alertModal",
      ref: alertModal,
      "ignore-force-clear": true,
      title: _unref(t)('MODAL.ALERT_TITLE')
    }, {
      footer: _withCtx(({ hide }) => [
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-primary",
          onClick: hide,
          autofocus: ""
        }, _toDisplayString(_unref(t)("MODAL.OK")), 9, _hoisted_1)
      ]),
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(alertMessage.value) + " ", 1)
      ]),
      _: 1
    }, 8, ["title"]),
    _createVNode(Modal, {
      id: "diagnotics-confirm",
      ref_key: "confirmModal",
      ref: confirmModal,
      title: _unref(t)('MODAL.CONFIRM_TITLE'),
      "ignore-force-clear": true
    }, {
      footer: _withCtx(({ hide }) => [
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-primary",
          onClick: ($event: any) => {
          confirmResult.value = true;
          hide();
        }
        }, _toDisplayString(_unref(t)("MODAL.OK")), 9, _hoisted_2),
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-secondary",
          autofocus: "",
          onClick: ($event: any) => {
          confirmResult.value = false;
          hide();
        }
        }, _toDisplayString(_unref(t)("MODAL.CANCEL")), 9, _hoisted_3)
      ]),
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(confirmMessage.value) + " ", 1)
      ]),
      _: 1
    }, 8, ["title"]),
    _createVNode(Modal, {
      id: "diagnotics-prompt",
      ref_key: "promptModal",
      ref: promptModal,
      "ignore-force-clear": true,
      title: _unref(t)('MODAL.PROMPT_TITLE')
    }, {
      footer: _withCtx(({ hide }) => [
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-primary",
          onClick: ($event: any) => {
          promptResult.value = promptInput.value;
          hide();
        }
        }, _toDisplayString(_unref(t)("MODAL.OK")), 9, _hoisted_5),
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-secondary",
          onClick: hide
        }, _toDisplayString(_unref(t)("MODAL.CANCEL")), 9, _hoisted_6)
      ]),
      default: _withCtx(() => [
        _createElementVNode("label", _hoisted_4, _toDisplayString(promptMessage.value), 1),
        _createElementVNode("div", null, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-control",
            id: "prompt-input",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((promptInput).value = $event)),
            autofocus: ""
          }, null, 512), [
            [
              _vModelText,
              promptInput.value,
              void 0,
              { trim: true }
            ]
          ])
        ])
      ]),
      _: 1
    }, 8, ["title"])
  ], 64))
}
}

})